import { NOTIFY_ERROR } from 'src/vuex/modules/snackbar/types'
import { SPINNER_TYPES } from 'src/vuex/types'
import {
  getPartnerBankDetails,
  getPartnerDetails,
  getPartners,
  updatePartner
} from '../apiCalls'
import texts from '../texts.json'
import * as types from './types'

export default {
  [types.GET_PARTNER]: async function ({ commit, dispatch }, partnerId) {
    try {
      dispatch(SPINNER_TYPES.SPINNER.SHOW)
      const partners = await getPartners()
      const foundPartner = partners.result.find(
        (partner) => partner.id === partnerId
      )
      const currentPartner = foundPartner ?? {}
      commit(types.SET_PARTNER, currentPartner)
    } catch (err) {
      console.error(err)
      commit(types.SET_PARTNER, null)
      dispatch(NOTIFY_ERROR, {
        message: texts.partner_error_message
      })
    } finally {
      dispatch(SPINNER_TYPES.SPINNER.HIDE)
    }
  },
  [types.GET_PRICING_DIALOG_INFO]: function ({ commit }, dialogInfo) {
    commit(types.SET_INFO_DIALOG, {
      isOpen: dialogInfo.value,
      title: dialogInfo.title,
      key: dialogInfo.key
    })
  },
  [types.CHANGE_IS_EDIT_MODE]: function ({ commit }, turn) {
    commit(types.SET_IS_EDIT_MODE, turn)
  },
  [types.CHANGE_IS_CONFIG_NOT_FOUND]: function ({ commit }, newValue) {
    commit(types.SET_IS_CONFIG_NOT_FOUND, newValue)
  },
  [types.GET_PARTNER_INFO]: async function ({ commit, dispatch }, partnerId) {
    dispatch(SPINNER_TYPES.SPINNER.SHOW)
    try {
      const response = await getPartnerDetails(partnerId)

      commit(types.SET_PARTNER_INFO, response)
    } catch (e) {
      commit(types.SET_PARTNER_INFO, {})
      console.error(e)
      dispatch(NOTIFY_ERROR, {
        message:
          'There was a problem with partner info. Contact with Tech team.'
      })
    } finally {
      dispatch(SPINNER_TYPES.SPINNER.HIDE)
    }
  },
  [types.GET_PARTNER_BANK_ACCOUNTS]: async function ({
    commit,
    state,
    dispatch
  }) {
    dispatch(SPINNER_TYPES.SPINNER.SHOW)
    try {
      const response = await getPartnerBankDetails(
        state.partnerDetails.id,
        state.partnerDetails.currency
      )
      commit(types.SET_PARTNER_BANK_ACCOUNTS, response.bank_details)
    } catch (e) {
      commit(types.SET_PARTNER_BANK_ACCOUNTS, [])
      console.error(e)
      dispatch(NOTIFY_ERROR, {
        message:
          'There was a problem with bank accounts. Contact with Tech team.'
      })
    } finally {
      dispatch(SPINNER_TYPES.SPINNER.HIDE)
    }
  },
  [types.UPDATE_PARTNER_INFO]: async function (
    { state, dispatch },
    { field, value }
  ) {
    dispatch(SPINNER_TYPES.SPINNER.SHOW)
    try {
      await updatePartner(state.partnerDetails.id, { [field]: value })
    } catch (e) {
      console.error(e)
      dispatch(NOTIFY_ERROR, {
        message:
          'There was a problem with bank accounts. Contact with Tech team.'
      })
    } finally {
      dispatch(SPINNER_TYPES.SPINNER.HIDE)
    }
  }
}
